import React, { FC, memo } from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { StyledWrapper, StyledText } from "./styled";

const Error: FC = () => {
  const { t } = useTranslation();

  return (
    <StyledWrapper>
      <StyledText>{t("pageNotFound.title")}</StyledText>
      <NavLink to="/">{t("pageNotFound.link")}</NavLink>
    </StyledWrapper>
  );
};

export default memo(Error);
